module.exports = __webpack_public_path__ + "img/info.64ddd48d.svg";